export default "__VITE_ASSET__CXrDUe8b__"